import React from 'react'
import css from './Music.module.css'

const Music = (props) => {
    return (
        <div>
            Music
        </div>
    )
}

export default Music;